<div class="error_page">
    <div class="error_page_name">403</div>
    <img src="/assets/img/403-error.png" alt="" class="error_page_img">
    <div class="error_page_title">Sorry!</div>
    <div class="error_page_text">The access to the page is forbidden!</div>
    <a class="error_page_btn" *ngIf="overViewAvailable$ | async" [routerLink]="toOverview">Go to Overview Page</a>
</div>
<div id="roadmap-paint-finished"></div>
